import type { ModelElementId } from '@view-model/domain/key';
import type { SelectedItemSet } from '@view-model/models/common/basic';
import type { Position } from '@view-model/models/common/types/ui';
import { LinkCreator } from '@view-model/models/common/components/LinkCreator';
import type { FileContainerCollectionContents } from '@view-model/models/sticky/FileContainer/domain/FileContainerCollectionContents';
import type { DescriptionPanelCollectionContents } from '@view-model/models/sticky/DescriptionPanel/domain/DescriptionPanelCollectionContents';
import type { AnnotationLinkOrigin } from '../domain/AnnotationLinkOrigin';

type Props = {
  fileContainerContents: FileContainerCollectionContents;
  panelContents: DescriptionPanelCollectionContents;
  selectedItems: SelectedItemSet<ModelElementId>;
  readonly: boolean;
  onLinkerStart(from: AnnotationLinkOrigin, startPosition: Position): void;
  onLinkerMove(currentPosition: Position): void;
  onLinkerEnd(currentPosition: Position): void;
};

export const AnnotationLinkCreator: React.FC<Props> = ({
  fileContainerContents,
  panelContents,
  selectedItems,
  readonly,
  onLinkerStart,
  onLinkerMove,
  onLinkerEnd,
}: Props) => {
  if (readonly || !selectedItems.isSingleSelected()) return null;

  const [id] = selectedItems.getSelectedItems();
  const fileContainerRect = fileContainerContents.getRect(id);
  const rect = fileContainerRect ?? panelContents.getRect(id);
  if (!rect) return null;

  const from: AnnotationLinkOrigin = { kind: fileContainerRect ? 'FileContainer' : 'DescriptionPanel', id };
  const origin = rect.topLeft();
  return (
    <g transform={origin.toSVGTranslate()}>
      <LinkCreator
        elementSize={{ width: rect.width, height: rect.height }}
        onLinkerStart={(position) => onLinkerStart(from, origin.add(position))}
        onLinkerMove={(position) => onLinkerMove(origin.add(position))}
        onLinkerEnd={(position) => onLinkerEnd(origin.add(position))}
      />
    </g>
  );
};
